import {isValidDate} from 'ramda-adjunct';

import {Nullish, parseDate} from 'shared/web';

/** The API date format ('yyyy-MM-dd') only represents four-digit years. */
const MAX_API_DATE_YEAR = 9999;
/** Below this, years are formatted as their BC era equivalent ('0000' becomes '0001'). */
const MIN_API_DATE_YEAR = 1;

/**
 * Parses a stored technical inspection value into a Date the API date format can
 * represent, or null.
 *
 * Being a valid Date is not enough — the year also has to survive serialization:
 * '12026-08-01' formats to '12026-08-01T00:00:00+02:00', which nothing can parse back
 * (this is what threw the RangeError in T20-133645 and is rejected by the API), and
 * '0000-08-01' formats to '0001-08-01', quietly changing the date. Both are treated as
 * absent so the user can enter a real date instead.
 */
export function parseTechnicalInspectionDate(technicalInspection: string | Nullish) {
  const date = parseDate(technicalInspection);

  if (!isValidDate(date)) {
    return null;
  }

  const year = date.getFullYear();

  return year >= MIN_API_DATE_YEAR && year <= MAX_API_DATE_YEAR ? date : null;
}
